import {
	FaFacebookF,
	FaInstagram,
	FaLinkedinIn,
	FaTwitter,
	FaYoutube,
} from "react-icons/fa";

export const footers = [
	{
		title: "Purchase",
		description: [
			{
				text: "Products",
				link: "/",
			},
			{
				text: "Unity Ads",
				link: "/",
			},
			{
				text: "Subscription",
				link: "/",
			},
			{
				text: "Asset Store",
				link: "/",
			},
			{
				text: "Resellers",
				link: "/",
			},
		],
	},
	{
		title: "Download",
		description: [
			{
				text: "Get Unity",
				link: "/",
			},
			{
				text: "Download Archive",
				link: "/",
			},
			{
				text: "Beta Program",
				link: "/",
			},
		],
	},
	{
		title: "Education",
		description: [
			{
				text: "Students",
				link: "/",
			},
			{
				text: "Educators",
				link: "/",
			},
			{
				text: "Certification",
				link: "/",
			},
			{
				text: "Learn",
				link: "/",
			},
			{
				text: "Center of Excellence",
				link: "/",
			},
		],
	},

	{
		title: "Unity Labs",
		description: [
			{
				text: "Labs",
				link: "/",
			},
			{
				text: "Publications",
				link: "/",
			},
		],
	},
	{
		title: "Resources",
		description: [
			{
				text: "Learn Platform",
				link: "/",
			},
			{
				text: "Community",
				link: "/",
			},

			{
				text: "Documentation",
				link: "/",
			},

			{
				text: "Unity QA",
				link: "/",
			},
			{
				text: "FAQ",
				link: "/",
			},
			{
				text: "Service Status",
				link: "/",
			},
			{
				text: "Connect",
				link: "/",
			},
			{
				text: "Case Studies",
				link: "/",
			},
			{
				text: "Made With Unity",
				link: "/",
			},
		],
	},
	{
		title: "Unity ",
		description: [
			{
				text: "Our Company",
				link: "/",
			},
			{
				text: "Newsletter",
				link: "/",
			},
			{
				text: "Blog",
				link: "/",
			},
			{
				text: "Events",
				link: "/",
			},
			{
				text: "Careers",
				link: "/",
			},
			{
				text: "Help",
				link: "/",
			},
			{
				text: "Press",
				link: "/",
			},
			{
				text: "Partners",
				link: "/",
			},
			{
				text: "Investors",
				link: "/",
			},

			{
				text: "Affiliates",
				link: "/",
			},
			{
				text: "Security",
				link: "/",
			},
			{
				text: "Social Impact",
				link: "/",
			},
		],
	},
];

export const legalLinks = [
	{
		text: "Legal",
		link: "/",
	},
	{
		text: "Privacy Policy",
		link: "/",
	},
	{
		text: "Cookies",
		link: "/",
	},
	{
		text: "Do Not Sell My Personal Information",
		link: "/",
	},
	{
		text: "Cookies Settings",
		link: "/",
	},
];

export const languageData = [
	"English",
	"Español",
	"Français",
	"中文",
	"日本語",
	"한국어",
	"Deutsch",
	"Русский",
	"Português",
];

export const socialLinks = [
	{
		icon: FaYoutube,
		link: "/",
	},
	{
		icon: FaLinkedinIn,
		link: "/",
	},
	{
		icon: FaTwitter,
		link: "/",
	},
	{
		icon: FaFacebookF,
		link: "/",
	},
	{
		icon: FaInstagram,
		link: "/",
	},
];
